module.exports = __webpack_public_path__ + "img/my-classifieds.f2befc8e.svg";